//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "SectionAgencyLegalInformationStatus",
  props: {
    status: {
      type: String,
      default: () => ""
    }
  }
};
